import React, { Component } from 'react';
import { Box, Grid, IconButton } from '@mui/material';
import InputText from '../../common/Form';
import { CloseRounded } from '@mui/icons-material';
import Creatable from '../../common/Creatable';

class SalaryLine extends Component {
    state = {  }

    handleChange = (e) => {
        const { name, value } = e.target;

        this.props.handleChange(name, value, this.props.index, this.props.type)
    }
    handleChangeCat = (option) => {
        console.log('====================================');
        console.log({option});
        console.log('====================================');
        if(!option){
            option = {value: "", label: ""}
        }
        this.props.handleChange("salary_line_name", option, this.props.index, this.props.type)
    }
    deleteLine = (e) => {
        this.props.deleteLine(this.props.index, this.props.type)
    }

    render() {
        const { index, errors, type, SALARY_CATS } = this.props;
        let bckg = index%2 === 0 ? "rgb(249, 240, 242)" : ""
        return (
            <Box p={1} style={{ background: bckg, borderRadius: "8px" }}>
                <Box >
                    <Grid item container>
                        <Grid item xs={1} md={12}>
                            <IconButton onClick={this.deleteLine}>
                                <CloseRounded />
                            </IconButton>
                        </Grid>
                        <Grid item xs={11} md={3}>
                            <Creatable
                                label="Intitulé"
                                required
                                error={errors.salary_line_name}
                                id={`salary_line_name-${index}-${type}`}
                                options={Object.values(SALARY_CATS).map( item => ({
                                    label: item.salary_cat_name,
                                    value: item.salary_cat_id,
                                    rate: item.salary_cat_rate
                                }))} // all salary_cat
                                value={this.props.salary_line_name}
                                openPopUp={this.props.openNewCat}
                                onChange={this.handleChangeCat}
                                // size="small"
                                // {...this.props}
                            />
                        </Grid>
                        
                        <Grid item xs={12} sm={2}>
                            <InputText
                                // size="small"
                                label="Base"
                                name="salary_line_base"
                                value={this.props.salary_line_base}
                                onChange={this.handleChange}
                                type="number"
                                error={errors.salary_line_base}
                                id={`salary_line_base-${index}-${type}`}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} md={1}>
                            <InputText
                                // size="small"
                                label="Taux"
                                name="salary_line_rate"
                                value={this.props.salary_line_rate}
                                onChange={this.handleChange}
                                type="number"
                                error={errors.salary_line_rate}
                                id={`salary_line_rate-${index}-${type}`}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} md={2}>
                            <InputText
                                // size="small"
                                label="Retenue"
                                name="salary_line_retenue"
                                value={this.props.salary_line_retenue}
                                onChange={this.handleChange}
                                type="number"
                                error={errors.salary_line_retenue}
                                id={`salary_line_retenue-${index}-${type}`}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} md={2}>
                            <InputText
                                // size="small"
                                label="Gain"
                                name="salary_line_gain"
                                value={this.props.salary_line_gain}
                                onChange={this.handleChange}
                                type="number"
                                error={errors.salary_line_gain}
                                id={`salary_line_gain-${index}-${type}`}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputText
                                // size="small"
                                label="Part Employeur"
                                name="salary_line_employer"
                                value={this.props.salary_line_employer}
                                onChange={this.handleChange}
                                type="number"
                                error={errors.salary_line_employer}
                                id={`salary_line_employer-${index}-${type}`}
                            />
                        </Grid>

                    </Grid>
                </Box>
            </Box>
        );
    }
}

export default SalaryLine;